import constants from './constants';

const getFileIdFromUrl = (url) => {
  let fileId = '';
  if (url.includes(constants.UNSPLASH_BASE_URL)) {
    const unsplashId = url.substring(url.indexOf('.com/') + 5, url.lastIndexOf('?'));
    fileId = `unsplash-${unsplashId}`;
  } else {
    const imgSrcSplit = url.split('/');
    fileId = imgSrcSplit[imgSrcSplit.length - 1];
  }

  return fileId;
};

export default getFileIdFromUrl;
